// If you change the font here, make sure to update the imported `fontStyles` css

export default {
  heading:
    'Saravek,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
  body: 'Saravek,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
};
